import { Outlet } from "react-router";
import { NavLink } from "react-router";
import HeaderNav from './Header'
import LeftMenu from './LeftMenu'
import Footer from './Footer'
// import C1 from '../assets/images/c1.jpg'
// import C2 from '../assets/images/c2.jpg'
// import C3 from '../assets/images/c3.jpg'
import Hero from '../assets/images/DN1.jpg'
import Brochure from "../assets/images/IETBHEC27_Brochure.png"
import Logo  from '../assets/images/IETBHEC.png'
import Danang_Desktop from '../assets/images/DH Danang.png'
import Danang_Mobile from '../assets/images/DH Danang.png'
import Template from "../assets/Paper_template_IETBHEC27.docx"

function Layout_Banner_7() {
    return (
        <>
            <div className="super_container">

                <div id="mySidenav" className="sidenav">
                    <LeftMenu />
                </div>

                <div className="home">
                    <HeaderNav />
                </div>
                <div className="hero-wrapper">
                <div
                    className="hero-header page-container"
                    style={{ backgroundImage: `url(${Hero})` }}
                >
                    <div className="hero-overlay">
                        <div className="hero-header-content">

                            {/* Left Side */}
                            <div className="hero-info">

                                <NavLink to="/">
                                    <img src={Logo} alt="Logo" className="main-logo" />
                                </NavLink>

                                <div className="hero-text">
                                    <h3>
                                        <strong>
                                            International Engineering, Technology, Business and Health Education Conference IETBHEC’27
                                        </strong>
                                    </h3>

                                    <p>
                                        <strong>
                                            (5th International Engineering and Technology Education Conference - IETEC)
                                        </strong>
                                    </p>

                                    <p><strong>Forging Futures Through Collaboration and Skill Empowerment: From Learning to Leading</strong></p>
                                    <p>#<strong>IETBHEC27</strong></p>
                                    <hr className="hero-divider" />

                                    <p>
                                        <strong>
                                            Da Nang, Vietnam | 25–27 February 2027
                                        </strong>
                                    </p>

                                    <NavLink to="/registration">
                                        <button id="hero-button">Register</button>
                                    </NavLink>
                                    <table className="w-full">
                                        <tbody>
                                            <tr>
                                                <td className="py-1">
                                                    <strong>Conference Brochure: </strong>
                                                    <a href={Brochure} target="_blank" rel="noreferrer noopener">
                                                        IETBHEC27_Brochure
                                                    </a>
                                                </td>

                                                <td className="text-right py-1">
                                                    <strong>Paper Template: </strong>
                                                    <a href={Template} target="_blank" rel="noreferrer noopener">
                                                        IETBHEC27_Template
                                                    </a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* Right Side */}
                            <div className="hero-sponsor">
                                <img
                                    src={Danang_Desktop}
                                    alt="Danang"
                                    className="hero-desktop-img"
                                />

                                <img
                                    src={Danang_Mobile}
                                    alt="Danang"
                                    className="hero-mobile-img"
                                />
                                <h4><strong>The University <br></br> of Da Nang - <br></br> University of Science <br></br> and Education</strong></h4>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
                <div className="page-container">
                <div className="content">
                    <Outlet />
                </div>
                </div>
                <div>
                    <Footer />
                </div>
            </div >
        </>
    )
}

export default Layout_Banner_7